import { BoardColumns, BoardData, boardEntityName, BoardType } from '@/backend/features/board-files/shared';
import { useBoardFormConfig } from '@/ui/features/board-files/hooks/useBoardFormConfig';
import { BoardFormDataType } from '@/ui/features/board-files/types/BoardFormDataType';
import { useTranslation } from '@/ui/hooks';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import { Row } from '@juvare/platform-shared/features/storage';
import React from 'react';

export function useHandleEditBoard(row: Row<BoardColumns>, reload: () => void) {
    const { t } = useTranslation();
    const formConfig = useBoardFormConfig(row.columns.type ? 'generic' : 'industry');
    const boardStorage = useStorageClient<BoardData, BoardColumns>(boardEntityName);
    return React.useCallback(() => {
        showFormDialog({
            title: t('editBoard'),
            config: formConfig,
            data: {
                board: row.columns.board,
                type: row.columns.type as BoardType | undefined,
                industry: row.columns.industry,
                description: { html: row.columns.descriptionHtml },
            } satisfies BoardFormDataType,
            onSubmit: ({ board, type, industry, description }: BoardFormDataType) => {
                return boardStorage
                    .post({
                        action: 'partial-update',
                        id: row.id,
                        data: {
                            board,
                            type,
                            industry,
                            descriptionHtml: description.html,
                        },
                    })
                    .then(() => reload())
                    .catch((error) => {
                        handleErrorDialog(error);
                        throw error;
                    });
            },
        });
    }, [row, reload, t, formConfig, boardStorage]);
}
